import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  from,
  split,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from "apollo-upload-client";
// import { RetryLink } from "@apollo/client/link/retry";
import { isAdmin } from "shared/utils/env";
import i18n from "shared/utils/i18n";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";

// const retryLink = new RetryLink();
const pathname = isAdmin ? "admin/graphql" : "partner/graphql";

const endpointHttp = `${window.location.origin}/${pathname}`;

const httpLink = createUploadLink({
  uri: endpointHttp,
  // useGETForQueries: true,
});

let errorsCount = 0;

const errorLink = onError(({ graphQLErrors, networkError }) => {
  // if (graphQLErrors)
  //   graphQLErrors.map(({ message, locations, path }) =>
  //     console.log(
  //       `[GraphQL error]: Message: ${message}, Location: ${locations
  //         .map((l) => `line ${l.line} column: ${l.column}`)
  //         .join(",")}, Path: ${path}`
  //     )
  //   );

  // if (networkError) console.log(`[Network error]: ${networkError}`);

  console.log({ graphQLErrors, networkError });

  errorsCount++;

  if (typeof window !== "undefined") {
    if (errorsCount > 100) {
      console.log("force reload");
      window.location.reload(true);
    }
  }
});

let viewerId = localStorage.getItem("viewerId");

const auth = new ApolloLink((operation, forward) => {
  // const isSameWindow = window.location === window.parent.location;
  // const url = isSameWindow ? window.location.href : window.parent.location.href;
  var url = document.location.href;

  const headers = {
    "Accept-Language": i18n.language.slice(0, 2),
    "X-Referer": url,
    "X-Client-Version": process.env.REACT_APP_SERVICE_VERSION || "development",
    "Apollo-Require-Preflight": "true",
  };

  operation.setContext({ headers });

  const result = forward(operation);

  if (!result.map) return result;

  return result.map((response) => {
    const context = operation.getContext();

    if (viewerId !== context.response.headers.get("x-viewerId")) {
      viewerId = context.response.headers.get("x-viewerId");
      localStorage.setItem("viewerId", viewerId);
    }

    return response;
  });
});

let wsUrl = `${window.location.protocol === "https:" ? "wss" : "ws"}://${
  window.location.host
}/${pathname}`;

if (process.env.REACT_APP_SUBSCRIPTION_URL) {
  wsUrl = process.env.REACT_APP_SUBSCRIPTION_URL;
}

const wsLink = new WebSocketLink({
  uri: wsUrl,
  options: {
    lazy: true,
    reconnect: true,
    connectionParams: () => {
      const params = {};

      const token = localStorage.getItem("token");

      if (token) {
        params.Authorization = token;
      }

      if (viewerId) {
        params.viewerId = viewerId;
      }

      return params;
    },
  },
});

const wsMutations = [];

const wsQuery = [];

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);

    if (!definition.kind === "OperationDefinition") {
      return false;
    }

    if (definition.operation === "subscription") {
      return true;
    }

    if (wsLink?.subscriptionClient?.client?.readyState !== 1) {
      return false;
    }

    if (definition.operation === "mutation") {
      return wsMutations.includes(definition.name.value);
    }

    if (definition.operation === "query") {
      return wsQuery.includes(definition.name.value);
    }

    return false;
  },
  wsLink,
  httpLink
);

export const client = new ApolloClient({
  link: from([errorLink, auth, link]),
  cache: new InMemoryCache({
    // typePolicies: {
    //   Query: {
    //     fields: {
    //       users: connectionPagination(),
    //     },
    //   },
    // },
  }),
});

// function connectionPagination() {
//   return {
//     keyArgs: false,
//     merge(existing, incoming) {
//       let nodes = existing ? existing.nodes : [];
//       nodes = nodes.concat(incoming.nodes);
//       const count = incoming.count;
//       return {
//         count,
//         nodes,
//       };
//     },
//   };
// }
